import React, { useState, useEffect } from 'react'
import CustomBreadcrumb from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate, Redirect } from 'react-router-dom';
import { changeNotificationStatus, getAppsConfig, getNotifications, getTotalUnreadNotifs, logout_user } from '../../services/http';
import { toast } from 'react-toastify';
import { BiCommentDetail, BiMessageRoundedError } from 'react-icons/bi';
import { RiMessage3Line } from 'react-icons/ri'; 
import useSWR from "swr";
import axios from "axios";
import { BASE_URL, CLIENT_SECRET, CLIENT_ID, CDN_BASE_URL } from '../../constants/constants';
import './Navbar.css';
import male_avatar from '../../assets/images/male_avatar.svg';
import female_avatar from '../../assets/images/female_avatar.svg';
import NotificationBadge from 'react-notification-badge';
import {Effect} from 'react-notification-badge';




const Navbar = () => {

    let monthArray = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);

    const [notifsCount, setNotifsCount] = useState(0);
    const [notifsList, setNotifsList] = useState([]);
    const [alertsList, setAlertsList] = useState([]);
    const [commentsList, setCommentsList] = useState([]);
    const [appName, setAppName] = useState("Supervison TEG")
    const [appLogo, setAppLogo] = useState(null)


    const fetcher = (url, token) =>
        axios
            .get(url, { headers: { Authorization: "Bearer " + token } })
            .then((res) => res.data);

     const { data, error } = useSWR(
        [`${BASE_URL}api/latest-alerts`, states.userToken.access_token],
        fetcher,
        { refreshInterval: 3000 }
    );

    if (error) { 
        if(error.response?.data?.code === 401) {
            const userCredentials = {
                "grant_type": "refresh_token",
                "refresh_token": states.userToken.refresh_token,
                "client_id": CLIENT_ID,
                "client_secret": CLIENT_SECRET
              }

              axios.post(`${BASE_URL}oauth/token`, userCredentials)
            .then(res => {
                dispatch({
                    type: "SET",
                    key: "userToken",
                    payload: res.data,
                  });
                  
            })
            .catch(error => {
                console.log(error.response)
                
            })
            console.log("error navbar", error.response.data.code)

        
        }
        if(error.response?.data?.code !== 401) {
            console.log(error)
        }
     };
    if (data) {
        console.log("Success latest ", data)
        // setNotifsList(data)
        dispatch({
            type: "SET",
            key: "notifList",
            payload: data,
        });
    };

    const updateNotifCount = async () => {
        let notif_count_response = await getTotalUnreadNotifs(states.userToken.access_token);
        if (notif_count_response.response && notif_count_response.response.status !== 200) {
            console.log(notif_count_response.response)
        } else {
           console.log("notif_count_response ", notif_count_response.data)
        //    setNotifsCount(notif_count_response?.data)
           dispatch({
            type: "SET",
            key: "notifCount",
            payload: notif_count_response?.data,
        });
        }

    }



    useEffect(() => {
       updateNotifCount()
    }, [data])
    

    // useEffect(() => {
    //     console.log(states)

    //     if (JSON.stringify(states.userInfo) === '{}' && JSON.stringify(states.userToken) === '{}') {
    //         navigate("/auth")
    //     }
    //     console.log("UserInfo ", states.userInfo)
    // }, [states.userToken.access_token, states.userInfo])

    const handleSignOut = async () => {
        const logout_response = await logout_user(states.userToken.access_token)
        console.log(logout_response)
        if (logout_response.response && logout_response.response.statut !== 200) {
            console.log(logout_response.response)
            toast.error(logout_response.response?.data?.error, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else {
            console.log(logout_response)
            toast.success("Déconnexion réussie !", {
                position: toast.POSITION.TOP_RIGHT,
                className: 'rotateY animated'
            });
            
            localStorage.removeItem(`persist:root`);
            localStorage.clear()
           
            // navigate("/auth")
        }

        dispatch({
            type: "SET",
            key: "userInfo",
            payload: {}
        })
        dispatch({
            type: "SET",
            key: "userToken",
            payload: {},
        });
        localStorage.removeItem(`persist:root`);

        states = undefined;
        navigate("/auth")
    }

    useEffect(() => {
        let alertsUnread = [];
        let commentsUnread = [];
        // if(notifsList == []){
    
            states.notifList?.map(item => {
                if (item.Type_alerte == "commentaire") {
                    commentsUnread.push(item)
                    console.log("Commentaire Top", item)
                }
                if (item.Type_alerte == "Alerte") {
                    alertsUnread.push(item)
                    console.log("Alerte Top", item)
                }
            })
            dispatch({
                type: "SET",
                key: "commentList",
                payload: commentsUnread,
            });
            dispatch({
                type: "SET",
                key: "alertList",
                payload: alertsUnread,
            });
            console.log("Hereee ", commentsUnread)
            // setCommentsList(commentsUnread)
            // setAlertsList(alertsUnread)
            console.log("Top ICIIIIII", states.commentList)
        // }

    }, [states.notifList])

    const readNotif = async (type, id) => {
        if (type === "commentaire") {
            const read_comment_response = await changeNotificationStatus(states.userToken.access_token, id, "comment")
            if (read_comment_response.response && read_comment_response.response.status !== 200) {
                console.log("data error ", read_comment_response.response)
            } else {
                console.log("update comment notif ", read_comment_response)
            }

            navigate(`/transmission-chat/${id}`)
        }
        if (type === "alerte") {
            const read_alert_response = await changeNotificationStatus(states.userToken.access_token, id, "alert")
            if (read_alert_response.response && read_alert_response.response.status !== 200) {
                console.log("data error ", read_alert_response.response)
            } else {
                console.log("update alert notif ", read_alert_response)

            }
            navigate(`/transmission/new`)
        }
    }
    
    const getAppliParams = async () => {
            let request = await getAppsConfig();
            if(request.response && request.response.status !== 200){
                console.log(request.response)
            } else {
                console.log("navbar app name ", request)
                setAppName(request.data?.applicationInterface?.application_name)
                setAppLogo(request.data?.applicationInterface?.application_favicon)
            }
    }
    useEffect(() => {
        getAppliParams();
    }, [])
    

    return (
        <>
            <div className="header-container fixed-top">
                <header className="header navbar navbar-expand-sm">

                    <ul className="navbar-item theme-brand flex-row  text-center">
                        <li className="nav-item theme-logo">
                            <a href="index.html">
                                <img 
                                    // src={appLogo !== null ? `${CDN_BASE_URL}${appLogo}` : `/assets/img/bcc_image.png`} 
                                    src="/assets/img/bcc_image.png" 
                                    className="navbar-logo" alt="logo" />
                            </a>
                        </li>
                        <li className="nav-item theme-text" onClick={() => navigate("/")}>
                            <div onClick={() => navigate("/dashboard")} className="nav-link"> 
                            {/* {appName} */}
                            Supervision TEG
                            </div>
                        </li>
                    </ul>

                    <ul className="navbar-item flex-row ml-md-auto">

                        <li className="nav-item dropdown notification-dropdown mr-3">
                            <a href="javascript:void(0);" className="nav-link dropdown-toggle" id="notificationDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {states.userInfo?.isAdmin === 0 &&  <NotificationBadge style={{padding: 3}} count={states.notifCount} effect={Effect.SCALE} />}
                               {states.userInfo?.isAdmin === 0 &&  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-bell">
                                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                </svg>}
                                {/* {states.notifCount != 0 && <span class="badge badge-error custom-badge-notif"></span>} */}
                                {/* <span style={{ color: 'red', fontSize: '15px', marginBottom: '20px' }} className="notif-unread-span">{states.notifCount != 0  && states.notifCount}</span> */}
                                {/* <span className="badge badge-success">5</span> */}
                            </a>
                            <div className="dropdown-menu position-absolute" aria-labelledby="notificationDropdown">
                                <div className="notification-scroll">
                                    {/* Start Comments */}
                                    <h6 className='ml-3 text-dark' style={{fontWeight: 'bold'}}>Commentaires</h6>
                                    {states.commentList && states.commentList?.length != 0 ?
                                        states.commentList?.map((item, index) =>
                                            <div key={index+"wscl"} className="dropdown-item" style={{ cursor: "pointer" }}>
                                                <div className="media">
                                                    <RiMessage3Line className="feather" style={{ width: "20", height: "20", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }} />
                                                    <div className="media-body">
                                                        <div
                                                            onClick={() => readNotif("commentaire", item.transmission?.id)}
                                                            className="notification-para"><span className="user-name"></span> Nouveau commentaire sur la transmission de <span className="user-name">{monthArray[parseInt(item.transmission?.mois)-1]} {item.transmission?.annee}</span></div>
                                                    </div>
                                                </div>
                                            </div>) :
                                        <h6 className="text-center">Aucune Notification récente</h6>}
                                    {/* End Comments */}

                                    {/* Start Alerts */}
                                    <h6 className='ml-3 text-dark' style={{fontWeight: 'bold'}}>Alertes</h6>
                                    {states.alertList && states.alertList?.length != 0 ?
                                        states.alertList?.map((item, index) =>
                                            <div key={index+"al"} className="dropdown-item" style={{ cursor: "pointer" }}>
                                                <div className="media">
                                                    <RiMessage3Line className="feather" style={{ width: "20", height: "20", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }} />
                                                    <div className="media-body">
                                                        <div
                                                            onClick={() => readNotif("alerte", item?.id)}
                                                            className="notification-para"><span className="user-name">Vous devez effectuer une transmission.</span></div>
                                                    </div>
                                                </div>
                                            </div>) :
                                        <h6 className='text-center'>Aucune Notification récente</h6>}
                                    {/* End Alert */}


                                    <div className="dropdown-item custom-dropdown-item" style={{ cursor: "pointer" }}>
                                        <div className="media">
                                            <div className="media-body">
                                                <div className="notification-para" onClick={() => navigate("/notifications")}><span className="user-name custom-user-name">Toutes les notifications</span> </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/*  */}


                            </div>
                        </li>

                        <li><div style={{ fontWeight: 'bold', marginTop: '10px' }}>{states.userInfo?.prenom}{" "}{states.userInfo?.nom}</div></li>

                        <li className="nav-item dropdown user-profile-dropdown">
                            <a href="javascript:void(0);" className="nav-link dropdown-toggle user" id="userProfileDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                <img src={states.userInfo?.sexe == "F" ? female_avatar : male_avatar} alt="avatar" />
                            </a>
                            <div className="dropdown-menu position-absolute" aria-labelledby="userProfileDropdown">
                                <div className="">
                                    <div className="dropdown-item" onClick={() => navigate(`/user`)}>
                                        <a className=""
                                        // href=""
                                        ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>{states.userInfo?.prenom}</a>
                                    </div>

                                    {/* <div className="dropdown-item">
                                        <a className="" href="auth_lockscreen.html"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-lock"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg> Lock Screen</a>
                                    </div> */}
                                    <div className="dropdown-item" 
                                         onClick={() => handleSignOut()}
                                    >
                                        <a className="" ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-log-out"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg> Se déconnecter</a>

                                    </div>
                                </div>
                            </div>
                        </li>

                    </ul>
                </header>
            </div>

            <div className="sub-header-container">
                <header className="header navbar navbar-expand-sm expand-header">
                    <a href="#" className="sidebarCollapse" data-placement="bottom"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg></a>

                    <CustomBreadcrumb />
                </header>


            </div>
        </>
    )
}

export default Navbar